import { useTranslation } from "react-i18next";
import { getRecipientCount, type AudienceListOption } from "src/utils/audienceListLabels";
import { formatNumber } from "src/utils/numberFormat";

/** "N people reached" for the selected audience lists, or undefined while the total is unknown. */
export const usePeopleReachedText = (
  options: AudienceListOption[],
  selectedNames: string[]
): string | undefined => {
  const { t, i18n } = useTranslation();
  const count = selectedNames.length ? getRecipientCount(options, selectedNames) : null;
  return count === null
    ? undefined
    : t("campaignFlow.aiWizard.basics.peopleReached", {
        count: formatNumber(count, {}, i18n.language),
      });
};
